import request, { METHODS } from "src/utils/api-base";

const unitApis = {
  createUnit: (payload: any) => {
    return request({
      route: "/app/units",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  getUnitList: (params: {
    page?: number;
    limit: number;
    status?: "active" | "inactive";
    search?: string;
  }) => {
    return request({
      route: "/app/units",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  editUnit: (payload: any) => {
    return request({
      route: `/app/units/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },

  deleteUnit: (_id: string) => {
    return request({
      route: `/app/units/${_id}`,
      method: METHODS.DELETE,
      auth: true,
    });
  },
};

export default unitApis;
